import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.ADD_ROW = function (state, payload) {
  state.rows.push(payload)
}
mutations.STUDENT = function (state, payload) {
  state.student = payload
}
mutations.DELETE = function (state, payload) {
  state.rows = payload
}
mutations.CHAPTER = function (state, payload) {
  state.chapter = payload
}
mutations.DELETE_ROW = function (state, payload) {
  state.rows.splice(payload, 1)
}
mutations.ADD_ROWS = function (state, payload) {
  state.rows = state.rows.concat(payload)
  state.rows.sort((a, b) => {
    return new Date(a.class_date) - new Date(b.class_date)
  })
}

const state = {
  rows: [],
  row: null,
  student: [],
  condition: {},
  chapter: [],
  loading: false
}
const actions = {
  init: ({ commit, state }, cond) => {
    const ctx = {
      data: {
        student: { api: 'M0602StudentService.findAllStudent' },
        unit: { api: 'M0404ClassUnitService.findClassUnit', input: cond.unit_cond },
        chapter: { api: 'M0201ChapterService.getChapterCodesForSelectBox', input: cond.chapter_cond }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('STUDENT', data.student.output)
        commit('FIND_ALL', data.unit.output)
        commit('CHAPTER', data.chapter.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0404ClassUnit cancel')
    commit('FIND_ALL', null)
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0404ClassUnit search')
    return client.postData({ data: { search: { api: 'M0404ClassUnitService.findClassUnit', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  addRow: ({ commit, state }) => {
    console.debug('called M0404ClassUnit add')
    commit('ADD_ROW',
      {
        id: null
        /* files: {},
        relates: {},
        belongs: {} */
      }
    )
  },
  add: ({ commit, state }) => {
    console.debug('called M0404ClassUnit add')
    commit('EDIT',
      {
        id: null
        /* files: {},
        relates: {},
        belongs: {} */
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0404ClassUnit edit')
    return client.postData({ data: { find: { api: 'M0404ClassUnitService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0404ClassUnit delete')
    return client.postData({ data: { delete: { api: 'M0404ClassUnitService.deleteDataDetails', input: row } } })
      .then((data) => {
        commit('DELETE', data.delete.output)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0404ClassUnit save')
    state.loading = true
    return client.postData({ data: { save: { api: 'M0404ClassUnitService.saveDataDetails', input: row } } })
      .then((data) => {
        state.loading = false
        commit('SAVE', data.save.output)
        SysUtils.showSuccess('Records saved successfully')
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0404ClassUnit download')
    return client.download({ data: { download: { api: 'M0404ClassUnitService.downloadData', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0404ClassUnit/M0404ClassUnitStore.js